module.exports = __webpack_public_path__ + "static/media/6.1724ca31.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/6.png
// module id = 1044
// module chunks = 0